<template>
  <li class="scheduler_user"
      @mouseenter="isShowSelectButton = true"
      @mouseleave="isShowSelectButton = false"
      :class="[
    {'isAbsence': user.dayAbsence.length > 0},
    {'isPotentialSub': user.dayAbsence.length < 1},
    {'item-is-headline': user.headline}]"
      :style="{'min-height': userMinHeight}">
    <div v-for="event in correctEventsFiltered"
         :data-key="user.id + '_' + event.obj.id"
         :key="user.id + '_' + event.obj.id"
         :content="i18n['from_another_school']"
         v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
                onShow: () => event.obj.hasOwnProperty('v_is_event_from_other_school')
              }"
         class="day-cal__event day-cal__event__lesson"
         :style="[
         {'top': event.row * 26 + hasAbsence + 'px'},
         {'left': event.left + 'px'},
         {'right': event.right + 'px'},
         {'height': '25px'}]"
         :class="[
         {'isActiveEvent animated bigPulseTwo infinite': activeEvent && event.obj.id === activeEvent.obj.id && activeUser && user.id === activeUser.id},
         {'day-cal__event__handled': event.obj.v_status === 1},
         {'day-cal__event__pending': event.obj.v_status === 2},
         {'day-cal__event day-cal__event__lesson--from-other-school': event.obj.v_is_event_from_other_school},
         {'day_cal__event__lesson__overlaps_absent': event.overlapsAbsent,
         'day_cal__event__lesson__canceled': event.obj.canceled },
         event.subs.length > 0 ? 'hint--left hint--success' : 'hint--right']"
         :ref="calEvent"
         :aria-label="allOnLessonHumanized(event)">
      <div class="day-cal__event__content" @click="setPopover(event, $event)">
        <div class="day-cal__event__subs">
          <div class="day-cal__event__other"
               v-if="event.othersOnLessonForBadge.length > 0">
            +<span class="icon-user"></span>
          </div>
          <img
            v-for="sub in event.subs"
            class="day-cal__event__subs__img"
            :src="sub && sub.default_thumb_url ? sub.default_thumb_url : ''"
            :alt="sub && sub.name ? sub.name : ''"/>
        </div>
        <div class="day-cal__event__content__title">
          <span class="nowrap day-cal__event__content__title__title">{{ event.obj.title }}</span>
          <span class="nowrap day-cal__event__content__title__grade"
                v-if="event.klassesOnLesson.length > 0">{{ event.klassesAsString }}</span>
        </div>
        <div class="day-cal__event__bg" :style="{backgroundColor: event.obj.color}"></div>
        <div class="day-cal__event__sider" :style="{backgroundColor: event.obj.color}"></div>
      </div>
    </div>
    <div class="day-cal__event work_hours"
         v-if="userAbsence.length < 1"
         v-for="presence in userPresenceForPlacing"
         :key="presence.obj.id"
         :style="[
         {'left': presence.left + 'px'},
         {'right': presence.right + 'px'}
         ]">
    </div>
    <div class="user_absence pointer" v-for="absence in userAbsenceForPlacing"
         :key="absence.obj.id"
         @click.stop="setPopover(absence)"
         :class="{'user_absence--stacked': absence.stackTop > 0}"
         :style="[
          {'left': absence.left + 'px'},
          {'right': absence.right + 'px'},
          {'top': absence.stackTop + 'px'},
          {'height': absence.stackHeight}]">
      <div class="user_absence__text" v-html="getAbsenceTitle(absence.obj)"></div>
    </div>
    <div class="select-user__button"
         :class="{'select-user__button--loading': selectButtonLoading}"
         @click="setAddSubstitute"
         :style="{left: (styleObj.left + 2) + 'px', right: (styleObj.right + 2) + 'px', backgroundColor: styleObj.color}"
         v-if="isShowSetAsSubButton">
    </div>
    <div class="select-user__button"
         :class="{'select-user__button--loading': isActiveEventsLoading}"
         @click="addSubToActiveEvents"
         :style="{left: (activeEvent.left + 2) + 'px', right: (activeEvent.right + 2) + 'px', backgroundColor: activeEvent.color}"
         v-for="activeEvent in activeEventsFiltered">
    </div>
  </li>
</template>

<script>
import doPopover from './SchedulerItemPopover'
import Moment from 'moment'
import {extendMoment} from 'moment-range'

const moment = extendMoment(Moment)
import docendo from '../../../docendo'

const I18N = {
  da: {
    multiple_days: 'Flere dage',
    ongoing: 'Løbende fravær',
    auto_created: 'Oprettet automatisk',
    from_another_school: 'Fra anden skole'
  },
  nb: {
    multiple_days: 'Flere dager',
    ongoing: 'Automatisk',
    auto_created: 'Løpende lengre fravær',
    from_another_school: 'Fra annen skole'
  },
  en: {
    multiple_days: 'Multiple days',
    ongoing: 'Automatic',
    auto_created: 'Autogenerated',
    from_another_school: 'From another school'
  }
}

export default {
  components: {doPopover},
  props: {
    user: {
      type: Object
    },
    locale: {
      default: 'da'
    },
    allEvents: {
      type: Array,
      default: () => []
    },
    isSubStatusPendingActive: {
      type: Boolean,
      default: false
    },
    allCalendarsInHash: {
      type: Object,
      default: () => {
      }
    },
    longAbsentListInHash: {
      type: Object,
      default: () => {
      }
    },
    isActiveEventsLoading: {
      default: false
    },
    theActiveEventsLoadingOnCalendarId: {
      default: null
    },
    activeEvents: {
      default: () => []
    },
    isHideEventsNotOverlappingAbsence: {
      type: Boolean,
      default: false
    },
    selectedEventTitleFilters: {
      type: Array,
      default: () => []
    },
    selectedQuickFilters: {
      type: Array,
      default: () => []
    },
    selectedClassFilters: {
      type: Array,
      default: () => []
    },
    selectedGroupFilters: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isShowSelectButton: false,
      selectButtonStyleObjForLoader: {color: ''},
      selectButtonLoading: false,
      slotWidth: 40,
      slotHeight: 40,
      absenceStackOffset: 13,
      rows: 1,
      firstEvent: true,
      correctEvents: [],
      subScoreMeta: [],
      oldSubScoreMeta: [],
      isEventsHasSortedOnce: false
    }
  },
  computed: {
    correctEventsFiltered () {
      let events = this.correctEvents
      if (this.isHideEventsNotOverlappingAbsence && this.user.dayAbsence.length > 0) {
        events = events.filter(event => event.overlapsAbsent)
      }
      const isAbsentUser = this.user.dayAbsence && this.user.dayAbsence.length > 0
      const hasOtherSubFilters = (this.selectedQuickFilters && this.selectedQuickFilters.length > 0) ||
        (this.selectedClassFilters && this.selectedClassFilters.length > 0) ||
        (this.selectedGroupFilters && this.selectedGroupFilters.length > 0)
      if (!isAbsentUser && !hasOtherSubFilters && this.selectedEventTitleFilters && this.selectedEventTitleFilters.length > 0) {
        events = events.filter(event => event.obj && this.selectedEventTitleFilters.indexOf(event.obj.title) > -1)
      }
      return events
    },
    activeEventsFiltered () {
      const hasActiveEventsAndLoading =
        this.activeEvents.length > 0 && this.isActiveEventsLoading && this.theActiveEventsLoadingOnCalendarId === this.user.user_calendar_id

      const shouldShowBecauseOfSelectButton =
        this.isShowSelectButton &&
        this.user.dayAbsence &&
        this.user.dayAbsence.length < 1 &&
        !this.user.headline

      if (hasActiveEventsAndLoading || shouldShowBecauseOfSelectButton) {
        return this.activeEvents
      }

      return []
    },
    i18n () {
      return I18N[this.locale]
    },
    isOnActiveEvent () {
      let arr = this.allEventsInAHash[this.activeEvent.obj.id].calendar_events ? this.allEventsInAHash[this.activeEvent.obj.id].calendar_events.map(cal => cal.calendar_id) : []
      // let arr = this.activeEvent.obj.calendar_events ? this.activeEvent.obj.calendar_events.map(cal => cal.calendar_id) : []
      return arr.indexOf(this.user.user_calendar_id) > -1
    },
    isShowSetAsSubButton () {
      return this.selectButtonLoading || (this.isShowSelectButton && (this.styleObj.color !== '') && this.user.dayAbsence.length < 1 && !this.user.headline && (this.activeEvent && this.activeEvent.obj.event_type !== 'absence') && !this.isOnActiveEvent)
    },
    schedulerActiveEvent () {
      return this.$store.state.subs.schedulerActiveEvent
    },
    styleObj () {
      return this.schedulerActiveEvent.obj ? this.schedulerActiveEvent : this.selectButtonStyleObjForLoader
    },
    activeEvent () {
      return this.$store.state.subs.activeEvent
    },
    activeUser () {
      return this.$store.state.subs.activeUser
    },
    isSortSubActive () {
      return this.$store.state.subs.isSortSubActive
    },
    users () {
      return this.$store.state.subs.allUsersAndEvents
    },
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    calsAndEventIds () {
      return this.$store.state.subs.allCalsWithEventIdsInHash
    },
    userLessons () {
      return this.user.dayEvents.map(eventId => this.allEventsInAHash[eventId])
    },
    userPresence () {
      return this.user.dayPresence.map(eventId => this.allEventsInAHash[eventId])
    },
    userAbsence () {
      return this.user.dayAbsence.map(eventId => this.allEventsInAHash[eventId])
    },
    hasAbsence () {
      return this.userAbsence.length > 1 ? 25 : this.userAbsence.length === 1 ? 12 : 0
    },
    userAbsenceForPlacing () {
      return this.userAbsence.map((event, index) => {
        const stackTop = this.absenceStackOffset * index
        return {
          'left': this.eventTop(event),
          'right': this.eventRight(event),
          'row': 0,
          'bottom': this.eventBottom(event),
          'obj': event,
          'stackTop': stackTop,
          'stackHeight': 'calc(100% - 1px - ' + stackTop + 'px)',
          'zIndex': stackTop > 0 ? 1000 : 100
        }
      })
    },
    userPresenceForPlacing () {
      return this.userPresence.map(event => {
        return {
          'left': this.eventTop(event),
          'right': this.eventRight(event),
          'obj': event
        }
      })
    },
    sortedEvents () {
      const arr = this.userLessons.map(lesson => {
        return {
          ...lesson,
          v_status: this.getSubstitutionStatusForUserCalId(lesson)
        }
      })
      return arr.sort((a, b) => {
        return moment(a.start).unix() - moment(b.start).unix()
      })
    },
    activeDate () {
      return this.$store.state.subs.date
    },
    isSchoolCalendarsLoading () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    userMinHeight () {
      const initialHeight = this.userAbsence.length > 1 ? 25 : 0
      return (initialHeight + (40 * this.rows)) + 'px'
    },
    showOverlappingClassBadge () {
      const settings = this.$store.state.schoolSettings || {}
      return settings.showOverlappingClassBadgeInSubstitution !== false
    }
  },
  watch: {
    sortedEvents () {
      this.rows = 1
      this.$emit('rows', {'rows': this.rows})
      this.correctEvents.splice(0, this.correctEvents.length)
      this.setWidthAndLeft()
    },
    isSchoolCalendarsLoading () {
      this.setWidthAndLeft()
    },
    showOverlappingClassBadge () {
      this.setWidthAndLeft()
    }
  },
  methods: {
    addSubToActiveEvents () {
      if (this.user.dayAbsence.length > 0 || this.activeEvents.length === 0) {
        return
      }
      this.$store.dispatch('addSubToActiveEvents', this.user.user_calendar_id)
    },
    getSerialListItem (reason) {
      return this.longAbsentListInHash[reason.event_serial_id] || false
    },
    getIsAbsenceOngoing (reason) {
      return this.getSerialListItem(reason) && this.getSerialListItem(reason).ongoing
    },
    getIsAbsenceAutoGenerated (reason) {
      let statusObj = reason.substitution_status ? JSON.parse(reason.substitution_status) : {}
      return statusObj['extended_at'] && moment(statusObj['extended_at']).isSame(moment(this.activeDate).format('YYYY-MM-DD'))
    },
    getIsAbsenceMultipleDays (reason) {
      let serialItem = this.getSerialListItem(reason)
      return serialItem && moment(serialItem.from_date).format('YYYY-MM-DD') !== moment(serialItem.to_date).format('YYYY-MM-DD')
    },
    getAbsenceTitle (reason) {
      var baseTitle = reason && reason.title ? reason.title : ''
      var title = baseTitle

      // 1) Typisk vej: langt de fleste har ikke away => tidlig "no-op"
      if (reason && reason.away === true && reason.calendar_events && reason.calendar_events.length) {
        var klassList = ''
        for (var i = 0; i < reason.calendar_events.length; i++) {
          var ev = reason.calendar_events[i]
          if (ev && ev.calendar_type === 'klass' && ev.name) {
            if (klassList.length) klassList += ', '
            klassList += ev.name
          }
        }
        if (klassList.length) title += ' - ' + klassList
      }

      // 2) Ongoing/multiple + badge logik (beregn kun én gang)
      var isOngoing = this.getIsAbsenceOngoing(reason)
      var isMultiple = this.getIsAbsenceMultipleDays(reason)
      var str = ''

      if (this.getIsAbsenceAutoGenerated(reason)) {
        str = '(' + this.i18n['ongoing'] + ')' +
          '<span class="marg-5-left badge badge--small badge--orange-warning">' +
          this.i18n['auto_created'] +
          '</span>'
      } else if (isOngoing || isMultiple) {
        str = isOngoing
          ? '(' + this.i18n['ongoing'] + ')'
          : '(' + this.i18n['multiple_days'] + ')'
      }

      if (str) title += ' - ' + str

      return title
    },
    allOnLessonHumanized (lesson) {
      if (!lesson) return [] // Early return if lesson is undefined or null

      if (lesson.subs && lesson.subs.length > 0) {
        return lesson.subs.map(obj => obj && obj.name ? obj.name : '')
      } else if (lesson.othersOnLessonForBadge) {
        return lesson.othersOnLessonForBadge.map((obj, idx) => obj && obj.name && idx < 3 ? obj.name : '')
      }

      return [] // Return an empty array if none of the conditions are met
    },
    usersOverlappingInClass (lesson) {
      const klassCals = lesson.calendar_events.filter(cal => cal.calendar_type === 'klass')
      const firstKlassCal = klassCals[0]
      if (!firstKlassCal) return []

      const calData = this.calsAndEventIds[firstKlassCal.calendar_id]
      if (!calData || !calData.lessons) return []

      const lessonRange = moment.range(lesson.start, lesson.end)
      const seen = {}
      const users = []

      calData.lessons.forEach(eventId => {
        const event = this.allEventsInAHash[eventId]
        if (!event || !event.calendar_events || event.id === lesson.id) return
        if (!lessonRange.overlaps(moment.range(event.start, event.end))) return

        event.calendar_events.forEach(cal => {
          if (cal.calendar_type !== 'user') return
          if (cal.calendar_id === this.user.user_calendar_id) return
          if (seen[cal.calendar_id]) return
          const user = this.users[cal.calendar_id]
          if (!user) return
          seen[cal.calendar_id] = true
          users.push(user)
        })
      })
      return users
    },
    mergeUsersForBadge (othersOnLesson, usersOverlappingInClass) {
      const seen = {}
      const users = []
      othersOnLesson.concat(usersOverlappingInClass).forEach(user => {
        if (!user || seen[user.user_calendar_id]) return
        seen[user.user_calendar_id] = true
        users.push(user)
      })
      return users
    },
    getSubstitutionStatusForUserCalId (lesson) {
      // Hvis lektionen er aflyst, så returner status 0 med det samme
      if (lesson.canceled === true) {
        return 1
      }

      // 0 = none, 1 = substituted, 3 = pending
      const statusObj = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
      const userStatus = statusObj[this.user.user_calendar_id] ? statusObj[this.user.user_calendar_id].status : 0

      if (this.isSubStatusPendingActive) {
        return userStatus
      } else {
        const isUserSubstituted = lesson.calendar_events.some(calEvent => calEvent.substitute_for_user_id === this.user.id)
        if (isUserSubstituted || userStatus === 1) {
          return 1
        } else {
          return 0
        }
      }
    },
    getLocaleTime (lesson) {
      const start = moment(lesson.start).format('LT')
      const end = moment(lesson.end).format('LT')
      return start + ' - ' + end
    },
    getSubs (activeEvent, userId) {
      const calendars = activeEvent.calendar_events
      return calendars.filter(calEvent => calEvent.substitute_for_user_id === userId)
    },
    setPopover (lesson, evt) {
      if (lesson.obj.v_is_event_from_other_school) {
        return
      }
      let activeEventIntoDbEvent = null
      // Hvis cmd/ctrl holdes nede: kør alternativt flow
      const isAltTrigger = evt && (evt.metaKey || evt.ctrlKey)
      if (isAltTrigger && this.user.dayAbsence.length > 0 && lesson.obj.event_type !== 'absence') {
        const dbEvent = {
          school_id: lesson.obj.school_id,
          event_id: lesson.obj.id,
          calendar_id: this.user.user_calendar_id,
          user_to_substitute: this.user.name,
          left: lesson.left,
          right: lesson.right,
          color: lesson.obj.color,
          lesson: lesson.obj,
          lessonLTTime: this.getLocaleTime(lesson.obj),
          selectedSubs: this.getSubs(lesson.obj, this.user.id)
        }
        if (this.activeEvent && this.activeEvent.obj.event_type !== 'absence') {
          activeEventIntoDbEvent = {
            school_id: this.activeEvent.obj.school_id,
            event_id: this.activeEvent.obj.id,
            calendar_id: this.activeUser.user_calendar_id,
            user_to_substitute: this.activeUser.name,
            left: this.activeEvent.left,
            right: this.activeEvent.right,
            color: this.activeEvent.obj.color,
            lesson: this.activeEvent.obj,
            lessonLTTime: this.getLocaleTime(lesson.obj),
            selectedSubs: this.getSubs(lesson.obj, this.activeUser.id)
          }
        }
        setTimeout(_ => {
          if (activeEventIntoDbEvent) {
            this.$store.commit('setActiveEvents', activeEventIntoDbEvent)
          }
          this.$store.commit('setActiveEvents', dbEvent)
        }, 100)
        this.$store.dispatch('trackEvent', 'substitution_altTrigger_used')
        return
      }
      this.$store.commit('clearActiveEvents')
      setTimeout(() => {
        let overlappingEvents = []
        if (this.isSortSubActive && this.user.dayAbsence.length > 0 && lesson.obj.event_type !== 'absence') {
          this.oldSubScoreMeta = this.subScoreMeta
          this.subScoreMeta = lesson.othersOnLesson
          this.allEvents.forEach(event => {
            const range1 = moment.range(lesson.obj.start, lesson.obj.end)
            const range2 = moment.range(event.start, event.end)
            if (range1.overlaps(range2)) {
              overlappingEvents.push(event)
            }
          })
        }
        this.$store.commit('setActiveUser', this.user)
        this.$store.commit('setActiveEvent', lesson)
        this.$store.dispatch('setActiveSchedulerEvent', {
          'obj': lesson.obj,
          'left': lesson.left,
          'right': lesson.right,
          'color': lesson.obj.color,
          'user': this.user,
          'userIsAbsent': this.user.dayAbsence.length > 0,
          'oldSubScoreMeta': this.oldSubScoreMeta,
          'othersOnLesson': lesson.othersOnLesson,
          'overlappingEvents': overlappingEvents
        })
      }, 100)
    },
    eventOverLapsAbsence (event) {
      let overlaps = false
      for (let i = 0; i < this.user.dayAbsence.length; i++) {
        let lesson = this.allEventsInAHash[this.user.dayAbsence[i]]
        const range1 = moment.range(lesson.start, lesson.end)
        const range2 = moment.range(event.start, event.end)
        if (range1.overlaps(range2)) {
          overlaps = true
        }
      }
      return overlaps
    },
    eventRight (event) {
      let time = moment.duration({
        minutes: moment(event.end).format('mm'),
        hours: moment(event.end).format('HH')
      }).asMinutes()
      let endOfDay = moment.duration({
        hours: 24,
        minutes: 0
      }).asMinutes()
      return ((this.slotWidth * 2) / 60) * (endOfDay - time)
    },
    eventTop (event) {
      let calStartTime = moment(event.start).set({
        'hour': 0,
        'minutes': 0
      })
      let eventStartTime = moment(event.start)
      let duration = moment(eventStartTime).diff(calStartTime)
      return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
    },
    eventHeight (event) {
      let duration = moment(event.end).diff(event.start)
      return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
    },
    eventBottom (event) {
      let calStartTime = moment(event.end).set({
        'hour': 0,
        'minutes': 0
      })
      let eventEndTime = moment(event.end)
      let duration = moment(eventEndTime).diff(calStartTime)
      return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
    },
    // Check if two events collide
    collidesWith (a, b) {
      return a.bottom > b.top && a.top < b.bottom
    },
    packEvents (columns) {
      let n = columns.length
      for (let i = 0; i < n; i++) {
        let col = columns[i]
        for (let j = 0; j < col.length; j++) {
          let ev = col[j]
          let colSpan = this.expandEvent(ev, i, columns)
          col[j].row = i
          if ((i + 1) > this.rows) {
            this.rows = i + 1
          }
          this.$emit('rows', {'rows': this.rows})
          col[j].colspan = colSpan / n
          const idx = this.correctEvents.findIndex(lesson => lesson.obj.id === col[j].obj.id)
          if (idx < 0) {
            this.correctEvents.push(col[j])
          } else {
            this.$set(this.correctEvents, idx, col[j])
          }
          // Scroll cal to first event
          if (this.firstEvent) {
            this.$emit('lessonsUpdate', this.correctEvents[0])
          }
          this.firstEvent = false
        }
      }
    },
    expandEvent (ev, iColumn, columns) {
      let colSpan = 1
      for (let i = iColumn + 1; i < columns.length; i++) {
        let col = columns[i]
        for (let j = 0; j < col.length; j++) {
          let ev1 = col[j]
          if (this.collidesWith(ev, ev1)) {
            return colSpan
          }
        }
        colSpan++
      }
      return colSpan
    },
    setWidthAndLeft () {
      this.isEventsHasSortedOnce = true
      let columns = []
      let lastEventEnding = null
      let events = this.sortedEvents.map(elem => {
        let subs = []
        let othersOnLesson = []
        let klassesOnLesson = []
        // let klasses = []
        elem.calendar_events.forEach(calEvent => {
          // remove user and set substitutes
          if (calEvent.calendar_id !== this.user.user_calendar_id && calEvent.substitute && calEvent.substitute_for_user_id === this.user.id) {
            subs.push(this.users[calEvent.calendar_id])
            // set othersOnLesson
          } else if (calEvent.calendar_type === 'user' && !calEvent.substitute && calEvent.calendar_id !== this.user.user_calendar_id) {
            othersOnLesson.push(this.users[calEvent.calendar_id])
          } else if (calEvent.calendar_type === 'klass' || calEvent.calendar_type === 'club') {
            klassesOnLesson.push(calEvent)
          }
        })
        const top = this.eventTop(elem)
        const height = this.eventHeight(elem)
        const bottom = this.eventBottom(elem)
        const right = this.eventRight(elem)
        const overlapsAbsent = this.eventOverLapsAbsence(elem)
        const usersOverlappingInClass = this.showOverlappingClassBadge
          ? this.usersOverlappingInClass(elem)
          : []
        return {
          'obj': elem,
          'top': top,
          'left': top,
          'right': right,
          'height': height,
          'bottom': bottom,
          'overlapsAbsent': overlapsAbsent,
          'subs': subs,
          'othersOnLesson': othersOnLesson,
          'othersOnLessonForBadge': this.mergeUsersForBadge(othersOnLesson, usersOverlappingInClass),
          'klassesOnLesson': klassesOnLesson,
          'klassesAsString': klassesOnLesson.filter(klass => klass && klass.name).map(klass => klass.name).join(', ')
        }
      })
      events.sort(function (e1, e2) {
        if (e1.top < e2.top) return -1
        if (e1.top > e2.top) return 1
        if (e1.bottom < e2.bottom) return -1
        if (e1.bottom > e2.bottom) return 1
        return 0
      })
      for (let i = 0; i < events.length; i++) {
        let e = events[i]
        if (lastEventEnding !== null && e.top >= lastEventEnding) {
          this.packEvents(columns)
          columns = []
          lastEventEnding = null
        }
        let placed = false
        for (let j = 0; j < columns.length; j++) {
          let col = columns[j]
          if (!this.collidesWith(col[col.length - 1], e)) {
            col.push(e)
            placed = true
            break
          }
        }
        if (!placed) {
          columns.push([e])
        }
        if (lastEventEnding === null || e.bottom > lastEventEnding) {
          lastEventEnding = e.bottom
        }
      }
      if (columns.length > 0) {
        this.packEvents(columns)
      }
    },
    setAddSubstitute () {
      if (this.selectButtonLoading) {
        return
      }
      // Dont click the button twice
      if (this.checkIfAvailableEventOverlaps(this.activeEvent, this.sortedEvents)) {
        let userEventObj = {userAsSub: this.user, eventToSub: this.activeEvent.obj, userToSub: this.activeUser}
        this.$emit('onChooseSubType', userEventObj)
        return
      }
      this.selectButtonStyleObjForLoader = this.schedulerActiveEvent
      this.selectButtonLoading = true
      if (this.isSubStatusPendingActive) {
        this.setSubStatus(this.activeEvent.obj, 2)
      }
      let userEventObj = {cal_id: this.user.user_calendar_id, event_id: this.activeEvent.obj.id}
      docendo.eventAddSubstitute(this.activeEvent.obj.id, this.user.id, this.activeUser.id, data => {
        this.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data))
        this.$store.commit('addEventOnAllUsersWithEvents', userEventObj)
        this.selectButtonLoading = false
        this.selectButtonStyleObjForLoader = {color: ''}
      })
    },
    checkIfAvailableEventOverlaps (eventToSubstitute, userEvents) {
      const startTime = moment(eventToSubstitute.obj.start)
      const endTime = moment(eventToSubstitute.obj.end)

      const overlappingAvailableEvents = userEvents.filter(event => {
        const eventStart = moment(event.start)
        const eventEnd = moment(event.end)
        return eventStart.isBefore(endTime) && eventEnd.isAfter(startTime) && event.event_type === 'available'
      })

      return overlappingAvailableEvents.length > 0
    },
    setSubStatus (lesson, num) {
      let statusData = this.getSubstitutionStatus(lesson)
      statusData[this.activeUser.user_calendar_id] = {'status': num}
      docendo.updateEvent(lesson.school_id, lesson.id, {substitution_status: JSON.stringify(statusData)}, success => {
        this.$store.commit('updateSubStatusOnEvent', {
          'eventId': lesson.id,
          'status': JSON.stringify(statusData)
        })
      })
    },
    getSubstitutionStatus (lesson) {
      return lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
    }
  },
  mounted () {
    this.rows = 1
    this.$emit('rows', {'rows': this.rows})
    this.setWidthAndLeft()
  }
}
</script>

<style scoped>

.scheduler_user {
  position: relative;
  height: 20px;
}

.day-cal__event {
  cursor: pointer;
  color: white;
  display: block;
  font-size: .85em;
  line-height: 1.3;
  font-weight: 400;
  position: absolute;
  top: 20px;
  left: 0%;
  right: 0%;
  border-right: 1px solid transparent !important;
  border-top: 1px solid transparent !important;
}

.day-cal__event.isActiveEvent {
  z-index: 100;
  box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2);
}

.day-cal__event__content {
  color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 3px 2px 3px 8px;
  left: 0;
  top: 0;
  font-size: 1rem;
  z-index: 1;
}

.day-cal__event__bg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
  opacity: 0.8;
}

.day-cal__event__lesson {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.scheduler_user.isAbsence .day-cal__event__bg {
  opacity: 0.5;
}

.scheduler_user.isAbsence .isActiveEvent .day-cal__event__bg {
  opacity: 1;
}

.scheduler_user.isAbsence .day-cal__event__bg {
  background-color: #ffffff !important;
  opacity: 1;
}

.scheduler_user.isAbsence .day-cal__event__content__title {
  color: #3e4450;
}

.scheduler_user.isAbsence .day_cal__event__lesson__overlaps_absent.day-cal__event__handled .day-cal__event__bg,
.scheduler_user.isAbsence .day-cal__event__handled .day-cal__event__bg {
  background-color: #3ecf8e !important;
  opacity: 1;
}

.scheduler_user.isAbsence .day_cal__event__lesson__overlaps_absent.day-cal__event__pending .day-cal__event__bg,
.scheduler_user.isAbsence .day-cal__event__pending .day-cal__event__bg {
  background-color: #f0b100 !important;
  opacity: 1;
}

.scheduler_user.isAbsence .day_cal__event__lesson__overlaps_absent.day-cal__event__handled .day-cal__event__content__title {
  color: #fff;
}

.day-cal__event__sider {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px;
  z-index: 2;
}

.day-cal__event__content__title {
  display: flex;
  position: absolute;
  top: 1px;
  bottom: 1px;
  left: 6px;
  display: flex;
  flex-direction: column;
  width: calc(100% - 8px);
  z-index: 2;
  font-size: 10px !important;
  overflow: hidden;
}

.day-cal__event__content__title__title {
  font-weight: bold;
}

.day-cal__event__content__title__grade {
  font-size: 8px;
}

.nowrap {
  white-space: nowrap;
}

.user_absence {
  position: absolute;
  top: 0;
  height: calc(100% - 1px);
  border-top: 12px solid rgb(86, 68, 55);
  background: rgb(86, 68, 55, 0.4) !important;
}

.user_absence__delete {
  position: absolute;
  width: 100px;
  top: 0;
  left: calc(100% + 5px);
  background-color: white;
  border: 1px solid #cccccc;
  z-index: 10000;
}

.user_absence__text {
  position: absolute;
  z-index: 10;
  top: -17px;
  left: 2px;
  height: 16px;
  overflow: hidden;
  color: #ffffff;
  font-size: 9px;
  text-transform: uppercase;
}

.work_hours {
  top: 0 !important;
  height: calc(100% - 5px) !important;
  bottom: 0 !important;
  background: rgba(153, 197, 244, .4) !important;
}

.item-is-headline {
  background-color: #3e4450 !important;
  color: #fff !important;
  font-weight: 700;
}

.day-cal__event__subs {
  position: absolute;
  top: 0px;
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.day-cal__event__subs__img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 2px;
}

.day-cal__event__other {
  background-color: #3e4450;
  border-radius: 50%;
  font-size: 10px;
  padding: 1px;
  text-align: center;
  overflow: hidden;
  height: 15px;
  width: 15px;
}

@keyframes bigPulse {
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.15, 1.15, 1.15);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}

.bigPulseTwo {
  animation-name: bigPulse;
}

.select-user__button {
  cursor: pointer;
  position: absolute;
  top: 1px;
  bottom: 1px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.25s;
  z-index: 1100;
  max-height: 32px;
}

.select-user__button:after {
  content: '+';
  color: #222;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eeeeee;
  border: 3px solid transparent;
  border-radius: 50%;
  transition: transform 0.15s;
}

.select-user__button:active {
  transform: scale(0.95);
}

.select-user__button--loading.select-user__button:after {
  content: '';
  animation: spin .7s linear infinite;
  border: 3px solid transparent;
  border-radius: 50%;
  border-top: 3px solid #f3f3f3;
  border-right: 3px solid #f3f3f3;
  border-bottom: 3px solid #f3f3f3;
  background: transparent;
}

.day-cal__event__lesson--from-other-school {
  box-shadow: none !important;
  cursor: not-allowed !important;
}

.day-cal__event__lesson--from-other-school .day-cal__event__bg,
.day-cal__event__lesson--from-other-school .day-cal__event__sider {
  background: repeating-linear-gradient(45deg, transparent, transparent 10px, #dfdfdf 10px, #ccc 20px), linear-gradient(to bottom, #959595, #999999);
}

.day-cal__event__lesson--from-other-school .day-cal__event__content__title {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.day_cal__event__lesson__canceled .day-cal__event__bg {
  position: absolute;
  z-index: 100;
  background-color: #fff !important;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'><path d='M100 0 L0 100 ' stroke='red' stroke-width='2'/><path d='M0 0 L100 100 ' stroke='red' stroke-width='2'/></svg>");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%, auto;
}

.day_cal__event__lesson__canceled .day-cal__event__content__title {
  color: #222;
  z-index: 101;
}

.user_absence--stacked {
  z-index: 0;
}

</style>



// WEBPACK FOOTER //
// SchedulerItem.vue?4c9112c8